// EN-4743. AAMVA dates to YYYY-MM-DD, the format the passport MRZ parser already
// produces, so a date reads the same whichever parser found it.
//
// Port of the kiosk's formatAamvaDate (visitly-kiosk-app/src/utils/idDates.js),
// logic unchanged. The kiosk's formatIdDateForDisplay isn't ported: visitors-web
// has no confirm screen that shows the date.

/**
 * @param raw 8 digits, as parseAamvaBarcode returns them.
 * @returns `YYYY-MM-DD`, or `raw` untouched when it isn't 8 digits.
 */
export const formatAamvaDate = <T>(raw: T): T | string => {
  if (typeof raw !== 'string' || !/^\d{8}$/.test(raw)) return raw;

  // AAMVA is MMDDCCYY for US jurisdictions and CCYYMMDD for Canadian ones. A
  // leading plausible year is the tie-break.
  const leading = Number(raw.slice(0, 4));
  if (leading >= 1900 && leading <= 2099) {
    return `${raw.slice(0, 4)}-${raw.slice(4, 6)}-${raw.slice(6, 8)}`;
  }
  return `${raw.slice(4, 8)}-${raw.slice(0, 2)}-${raw.slice(2, 4)}`;
};
